import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { useToken } from '@hub/design-system-base';
import { Box } from '@hub/box';
import { Stack } from '@hub/stack';
import Color from 'color';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MAX_DOTS = 3;

const Dot = _ref => {
  let {
    selected
  } = _ref;
  return /*#__PURE__*/_jsx(Box, {
    sx: _objectSpread(_objectSpread({
      width: 'size-2',
      height: 'size-2',
      borderRadius: 'full'
    }, selected && {
      background: 'white'
    }), {}, {
      border: '1px solid',
      borderColor: 'white'
    }),
    "data-id": "feature_dots_Dot_Box"
  });
};

export const Dots = _ref2 => {
  let {
    scrollPosition,
    totalFrames,
    sx
  } = _ref2;
  const buttonBackgroundColor = Color(useToken('colors', 'licorice')).alpha(0.5) // eslint-disable-line no-magic-numbers
  .rgb().string();
  return /*#__PURE__*/_jsxs(Stack, {
    direction: "row",
    shouldWrapChildren: false,
    gap: "spacing-sm",
    sx: _objectSpread({
      background: buttonBackgroundColor,
      alignSelf: 'stretch',
      alignItems: 'center'
    }, sx),
    "data-id": "feature_dots_Dot_Stack",
    children: [/*#__PURE__*/_jsx(Dot, {
      selected: scrollPosition === 'start',
      "data-id": "feature_dots_Stack_Dot"
    }), totalFrames >= MAX_DOTS ? /*#__PURE__*/_jsx(Dot, {
      selected: scrollPosition === 'middle',
      "data-id": "feature_dots_Dot_3"
    }) : null, /*#__PURE__*/_jsx(Dot, {
      selected: scrollPosition === 'end' || totalFrames === MAX_DOTS - 1 && scrollPosition === 'middle',
      "data-id": "feature_dots_Stack_Dot_4"
    })]
  });
};